(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('headend', {
            parent: 'entity',
            url: '/headend',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.headend.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/headend/headends.html',
                    controller: 'HeadendController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('headend');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('headend-detail', {
            parent: 'headend',
            url: '/headend/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.headend.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/headend/headend-detail.html',
                    controller: 'HeadendDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('headend');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Headend', function($stateParams, Headend) {
                    return Headend.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'headend',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('headend-detail.edit', {
            parent: 'headend-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/headend/headend-dialog.html',
                    controller: 'HeadendDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Headend', function(Headend) {
                            return Headend.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('headend.new', {
            parent: 'headend',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/headend/headend-dialog.html',
                    controller: 'HeadendDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                bsiCode: null,
                                headendType: null,
                                headendName: null,
                                headendAddress: null,
                                headendCity: null,
                                headendState: null,
                                headendZip: null,
                                headendContactName: null,
                                headendPhoneNumber: null,
                                downlinkLocation: null,
                                boxFeeMot: null,
                                boxFeeNonMot: null,
                                dtaFee: null,
                                minimumFee: null,
                                usingNonMotCode: false,
                                nctcMember: false,
                                nctcMemberId: null,
                                nctcSystemId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('headend', null, { reload: 'headend' });
                }, function() {
                    $state.go('headend');
                });
            }]
        })
        .state('headend.edit', {
            parent: 'headend',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/headend/headend-dialog.html',
                    controller: 'HeadendDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Headend', function(Headend) {
                            return Headend.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('headend', null, { reload: 'headend' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('headend.delete', {
            parent: 'headend',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/headend/headend-delete-dialog.html',
                    controller: 'HeadendDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Headend', function(Headend) {
                            return Headend.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('headend', null, { reload: 'headend' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
